import { format } from "date-fns";

export function FormatDate(date: string): string {
  if (date) {
    return format(new Date(date), "dd.MM.yyyy");
  }
  else
    return '';
}

export function FormatDateShort(date: string): string {
  if (date) {
    return format(new Date(date), "dd.MM.yy");
  } else {
    return '';
  }
}

export function GetTodayDate(): string {
  return format(new Date(), "dd.MM.yyyy");
}

export function GetIsoDateTimeStamp(isoDateTime: string) {
  const date = new Date(isoDateTime);
  const locale = "sr-RS";
  return `${date.toLocaleTimeString(locale)}, ${date.toLocaleDateString(
    locale
  )}`;
}

export function FormatTime(dateTime: string) {
  if (dateTime) {
    return format(new Date(dateTime), "HH:mm:ss");
  } else {
    return '';
  }
}

export function FormatDateIso(date: Date): string {
  var isoDateTime = new Date(
    date.getTime() - date.getTimezoneOffset() * 60000
  ).toISOString();

  return isoDateTime.substr(0, 10);
}

export function GetLastYears(number: number): number[] {
  let result = [];
  let currentYear = new Date().getFullYear();
  for (let i = currentYear; i > currentYear - number; i--) {
    result.push(i);
  }

  return result;
}

export function getYestardaysDate() {
  const date = new Date();
  date.setDate(date.getDate() - 1);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return (`${year}-${month}-${day}`);
}

export function GetYearsBetween(year1: number, year2: number): number[] {
  let result = [];
  for (let i = year2; i >= year1; i--) {
    result.push(i);
  }

  return result;
}

export function DiffDays(dateString1: string, dateString2?: string): number {
  const ONE_DAY = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
  let date1: Date = new Date(dateString1);
  let date2: Date = dateString2 ? new Date(dateString2) : new Date();
  let timeInMilisec: number = date1.getTime() - date2.getTime();
  let daysBetweenDates: number = Math.ceil(timeInMilisec / ONE_DAY);

  return daysBetweenDates;
}

export function getFristDateOfCurrnetMonth(): Date {
  var date = new Date(),
    y = date.getFullYear(),
    m = date.getMonth();
  return new Date(y, m, 1);
}

export function getLastDateOfCurrnetMonth(): Date {
  var date = new Date(),
    y = date.getFullYear(),
    m = date.getMonth();
  return new Date(y, m + 1, 0);
}

export function getLastDateOfMonth(date: Date): Date {
  const y = date.getFullYear();
  const m = date.getMonth();
  return new Date(y, m + 1, 0);
}

export function MonthNumberToText(num: number): string {
  switch (num) {
    case 1:
      return "Januar";
    case 2:
      return "Februar";
    case 3:
      return "Mart";
    case 4:
      return "April";
    case 5:
      return "Maj";
    case 6:
      return "Jun";
    case 7:
      return "Jul";
    case 8:
      return "Avgust";
    case 9:
      return "Septembar";
    case 10:
      return "Oktobar";
    case 11:
      return "Novembar";
    case 12:
      return "Decembar";
    default:
      return "";
  }
}

export const mapMonths = (month: string) => {
  switch (month) {
    case "JANUARY":
      return "JANUAR";
    case "FEBRUARY":
      return "FEBRUAR";
    case "MARCH":
      return "MART";
    case "APRIL":
      return "APRIL";
    case "MAY":
      return "MAJ";
    case "JUNE":
      return "JUN";
    case "JULY":
      return "JUL";
    case "AUGUST":
      return "AVGUST";
    case "SEPTEMBER":
      return "SEPTEMBAR";
    case "OCTOBER":
      return "OKTOBAR";
    case "NOVEMBER":
      return "NOVEMBAR";
    case "DECEMBER":
      return "DECEMBAR";
  }
};
